function renderBuildSingleDevModeSnippetsImportsTemplate({
  singular,
  actionModulePath,
  camelSingular
}: {
  singular: string
  actionModulePath: string
  camelSingular: string
}): string {
  return `import { get${singular} } from '${actionModulePath}'

export default async function ${singular}Summary() {
  const ${camelSingular} = await get${singular}()

  if (!${camelSingular}) {
    return null
  }

  return <pre>{JSON.stringify(${camelSingular}, null, 2)}</pre>
}
`
}

function renderBuildSingleDevModeSnippetsClientModuleTemplate({
  singular,
  actionModulePath,
  tsObject,
  toLowerCase
}: {
  singular: string
  actionModulePath: string
  tsObject: string
  toLowerCase: string
}): string {
  return `'use client'

import * as React from 'react'
import { upsert${singular}, type ${singular}UpsertInput } from '${actionModulePath}'

const input: ${singular}UpsertInput = ${tsObject}

export function Save${singular}Button() {
  const [isPending, startTransition] = React.useTransition()

  return (
    <button
      type="button"
      disabled={isPending}
      onClick={() => {
        startTransition(async () => {
          await upsert${singular}(input)
        })
      }}
    >
      Save ${toLowerCase}
    </button>
  )
}
`
}

export function renderBuildSingleDevModeSnippetsRenderer(
  request:
    | {
        kind: 'renderBuildSingleDevModeSnippetsImportsTemplate'
        props: {
          singular: string
          actionModulePath: string
          camelSingular: string
        }
      }
    | {
        kind: 'renderBuildSingleDevModeSnippetsClientModuleTemplate'
        props: {
          singular: string
          actionModulePath: string
          tsObject: string
          toLowerCase: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderBuildSingleDevModeSnippetsImportsTemplate':
      return renderBuildSingleDevModeSnippetsImportsTemplate(request.props)
    case 'renderBuildSingleDevModeSnippetsClientModuleTemplate':
      return renderBuildSingleDevModeSnippetsClientModuleTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
